import { USER_PROFILES_ACTIONS } from '../actions/userProfiles.actions';
import { UserProfile } from '../../models/user-profile';

export function userProfilesReducer(state: UserProfile[] = null, action) {
  switch (action.type) {

    case USER_PROFILES_ACTIONS.SET_USER_PROFILES:
      return Object.assign([], action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/user-profiles.reducer.ts